import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Reminder = forwardRef<SVGSVGElement, IconProps>(({ size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M3 14.1949C3 13.6427 3.44772 13.1949 4 13.1949H27.9999C28.5522 13.1949 28.9999 13.6427 28.9999 14.1949V26.2468C28.9999 27.6275 27.8806 28.7468 26.4999 28.7468H5.5C4.11929 28.7468 3 27.6275 3 26.2468V14.1949Z"
        fill="#FFBA08"
      />
      <path
        d="M14.2149 5.29004L3.40417 13.3106C3.14991 13.4992 3 13.7971 3 14.1137V21.7243H28.9882V14.0795C28.9882 13.7624 28.8379 13.4641 28.583 13.2756L17.7867 5.28769C16.7253 4.50239 15.2753 4.50334 14.2149 5.29004Z"
        fill="#FFBA08"
      />
      <path
        d="M3.70208 13.7122L14.5128 5.69159C15.3965 5.03601 16.6048 5.03522 17.4893 5.68964L28.2856 13.6775C28.4131 13.7718 28.4882 13.9209 28.4882 14.0795V21.2243H3.5V14.1137C3.5 13.9554 3.57496 13.8065 3.70208 13.7122Z"
        stroke="#E48900"
        strokeOpacity="0.29"
      />
      <g filter="url(#filter0_bd_2383_1068)">
        <path
          d="M6.01636 7.09998C6.01636 6.54769 6.46407 6.09998 7.01636 6.09998H24.9838C25.5361 6.09998 25.9838 6.54769 25.9838 7.09998V15.5553C25.9838 21.0691 21.5139 25.539 16.0001 25.539C10.4862 25.539 6.01636 21.0691 6.01636 15.5553V7.09998Z"
          fill="white"
          fillOpacity="0.88"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_2383_1068)">
        <ellipse cx="15.9941" cy="18.4535" rx="6.58578" ry="6.58578" fill="url(#paint0_linear_2383_1068)" />
      </g>
      <g filter="url(#filter2_d_2383_1068)">
        <ellipse cx="15.9941" cy="17.2802" rx="6.58578" ry="6.58578" fill="url(#paint1_linear_2383_1068)" />
      </g>
      <g filter="url(#filter3_d_2383_1068)">
        <path
          d="M14.2191 9.95617C13.8699 9.35135 13.2948 8.91002 12.6202 8.72926C11.9456 8.54851 11.2268 8.64313 10.622 8.99233C10.0172 9.34152 9.57588 9.91667 9.39512 10.5913C9.21437 11.2659 9.30899 11.9846 9.65819 12.5894L11.9387 11.2728L14.2191 9.95617Z"
          fill="url(#paint2_linear_2383_1068)"
        />
      </g>
      <g filter="url(#filter4_d_2383_1068)">
        <path
          d="M17.739 9.95617C18.0882 9.35135 18.6633 8.91002 19.3379 8.72926C20.0125 8.54851 20.7313 8.64313 21.3361 8.99233C21.9409 9.34152 22.3823 9.91667 22.563 10.5913C22.7438 11.2659 22.6491 11.9846 22.2999 12.5894L20.0195 11.2728L17.739 9.95617Z"
          fill="url(#paint3_linear_2383_1068)"
        />
      </g>
      <g filter="url(#filter5_d_2383_1068)">
        <path
          d="M15.9941 12.0619L15.9941 17.6763L18.4248 20.2413"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <g filter="url(#filter6_d_2383_1068)">
        <circle cx="15.9725" cy="17.6248" r="1.44115" fill="white" />
      </g>
      <g filter="url(#filter7_b_2383_1068)">
        <path
          d="M28.0714 27.3536L3.74282 13.8377C3.40956 13.6526 3 13.8936 3 14.2748V23.6393L3.92857 27.3536L26.2142 28.7464L28.0714 27.3536Z"
          fill="url(#paint4_linear_2383_1068)"
        />
      </g>
      <g filter="url(#filter8_b_2383_1068)">
        <path
          d="M3.37416 27.8381L28.2549 13.8441C28.5882 13.6567 29 13.8975 29 14.2799V24.5679L26.2143 28.7464H6.71434L3.37416 27.8381Z"
          fill="url(#paint5_linear_2383_1068)"
        />
      </g>
      <g>
        <path
          d="M28.8597 13.4821L26.4281 11.6817L3.28064 26.7626L3.98208 27.6277L28.8597 13.4821Z"
          fill="url(#paint6_linear_2383_1068)"
          fillOpacity="0.13"
        />
      </g>
      <g>
        <path
          d="M3.18112 13.4937L5.642 11.6817L16.865 20.2392L16.0817 20.777L3.18112 13.4937Z"
          fill="url(#paint7_linear_2383_1068)"
          fillOpacity="0.13"
        />
      </g>
      <defs>
        <filter
          id="filter0_bd_2383_1068"
          x="2.01636"
          y="2.09998"
          width="27.9674"
          height="27.439"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2383_1068" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_backgroundBlur_2383_1068" result="effect2_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter1_d_2383_1068"
          x="5.40833"
          y="8.86774"
          width="21.1715"
          height="21.1716"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter2_d_2383_1068"
          x="5.40833"
          y="7.69446"
          width="21.1715"
          height="21.1716"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter3_d_2383_1068"
          x="5.30542"
          y="5.63953"
          width="12.9137"
          height="11.9499"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter4_d_2383_1068"
          x="13.739"
          y="5.63953"
          width="12.9137"
          height="11.9499"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter5_d_2383_1068"
          x="13.2441"
          y="11.3119"
          width="7.93066"
          height="13.6794"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter6_d_2383_1068"
          x="13.5314"
          y="15.1837"
          width="4.88232"
          height="4.88232"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter7_b_2383_1068"
          x="-4"
          y="6.77411"
          width="39.0714"
          height="28.9724"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2383_1068" result="shape" />
        </filter>
        <filter
          id="filter8_b_2383_1068"
          x="-3.62585"
          y="6.77917"
          width="39.6259"
          height="28.9673"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2383_1068" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2383_1068" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2383_1068"
          x1="22.5799"
          y1="19.2037"
          x2="8.94554"
          y2="19.2037"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C55CFB" />
          <stop offset="1" stopColor="#FF6B00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2383_1068"
          x1="22.5799"
          y1="18.0304"
          x2="8.94554"
          y2="18.0304"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C55CFB" />
          <stop offset="1" stopColor="#FF6B00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2383_1068"
          x1="16.4444"
          y1="10.5826"
          x2="8.34155"
          y2="11.2728"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C55CFB" />
          <stop offset="1" stopColor="#FF9800" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2383_1068"
          x1="21.3361"
          y1="8.99233"
          x2="12.0574"
          y2="8.64415"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C55CFB" />
          <stop offset="1" stopColor="#FF9800" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2383_1068"
          x1="15.2645"
          y1="13.425"
          x2="15.2645"
          y2="28.7464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB500" stopOpacity="0" />
          <stop offset="1" stopColor="#FFBA08" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2383_1068"
          x1="16.4643"
          y1="13.425"
          x2="16.4643"
          y2="28.7464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB500" stopOpacity="0" />
          <stop offset="1" stopColor="#FFBA08" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2383_1068"
          x1="11.277"
          y1="22.2266"
          x2="11.9317"
          y2="23.1385"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2383_1068"
          x1="11.0898"
          y1="16.0306"
          x2="9.68695"
          y2="17.9946"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default Reminder
